import { render, staticRenderFns } from "./StoreDetail.vue?vue&type=template&id=521ff195&scoped=true&"
import script from "./StoreDetail.vue?vue&type=script&lang=ts&"
export * from "./StoreDetail.vue?vue&type=script&lang=ts&"
import style0 from "./StoreDetail.vue?vue&type=style&index=0&id=521ff195&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521ff195",
  null
  
)

export default component.exports